import React, { ReactElement } from 'react';

const LanguageElement = (props: any): ReactElement => {
  return (
    <div  className="language-element" data-testid="languageElement">
      {/* WCAG 2.1.1 / 4.1.2: cada idioma es un boton nativo, operable con teclado. */}
      <button
        type="button"
        lang={props.idLang}
        data-qa={props.idLang}
        id={props.idLang}
        aria-current={props.isSelected ? 'true' : undefined}
        onClick={() => props.handleSelectLanguage(props.idLang)}
      >
        <span aria-hidden="true"></span><span>{props.label}</span>
      </button>
    </div>
  );
};

export default LanguageElement;
